// BootstrapのJavaScript側の機能を読み込む
import 'bootstrap';
import 'slick-carousel';
// Bootstrap以外のJavaScriptを読み込む
import './js/i-measure_script.js';
// HTMLファイルを読み込む
import './index.html';
// スタイルシートを読み込む
import './scss/i-measure_styles.scss';

document.onreadystatechange = function () {
  if (document.readyState === 'complete') {
    const iframe  = document.querySelector('iframe');
    iframe.setAttribute('scrolling', 'no');
  }
};



